var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.78334V16.4093H12.3017L18.5345 23.3333L25 16.1423V0H0V7.78334ZM18.5345 22.107L13.4483 16.451H23.6207L18.5345 22.107ZM24.1379 15.6167H0.862069V8.61757H24.1379V15.6167ZM0.862069 0.859254H24.1379V7.80837H0.862069V0.859254Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownMessage);
export default __webpack_public_path__ + "static/media/dropdownMessage.3e98673ae90723bfa8544386c2ca818b.svg";
export { ForwardRef as ReactComponent };